import React, {Component} from 'react';
import GoogleMap from 'google-map-react';
import {fitBounds} from 'google-map-react/utils';
import StoreMarker from './Elements/StoreMarker';
import DriverMarker from './Elements/DriverMarker';
import config from '../../config/config.js'
import './Map.css';
import commons from "../../script/utils/commons";

// FIXME Directions rendering is being managed manually.
// we should switch to tomchentw's react-google-maps module
// which will allow to remove this conditional rendering


const TAG = 'MAP';


// Updating 25 times/second
const INTERVAL_DELAY = 80;
const TRANSITION_ITERATIONS = 200;
const MARKER_ANIMATION = true;
export default class Map extends Component {


    constructor(props) {
        super(props);
        this.state = {
            id: "Drivers Map",
            drivers: {},
            intervalId: null,
            directionsOrder: null,
        };


        this.internal = {
            gmaps: null,
            map: null,
            directionsDisplay: null,
            directionsService: null,
        };

    }

    componentDidMount() {
        this.removeMapUpdate();
    }


    setupMapUpdate() {

        if (!this.state.intervalId) {
            let intervalId = setInterval(() => this.updateDriversLocation(), INTERVAL_DELAY);
            this.state['intervalId'] = intervalId;
        }
    }

    removeMapUpdate() {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
            this.state['intervalId'] = null;
        }
    }

    componentWillUnmount() {
        this.removeMapUpdate();
    }

    getBounds(markers) {
        return {
            nw: {
                lat: Math.max(...markers.map(marker => marker.lat)),
                lng: Math.min(...markers.map(marker => marker.lng)),
            },
            se: {
                lat: Math.min(...markers.map(marker => marker.lat)),
                lng: Math.max(...markers.map(marker => marker.lng)),
            },
        };
    }

    onGoogleApiLoaded(mapInstance, gmapsLoaded) {
        let map = mapInstance;
        let gmaps = gmapsLoaded;

        let directionsDisplay = null;
        let directionsService = null;


        this.internal = {
            google: gmaps,
            map: map,
        };


        if (gmapsLoaded) {
            directionsDisplay = new gmapsLoaded.DirectionsRenderer({map: map, suppressMarkers: true});
            directionsService = new gmapsLoaded.DirectionsService();

            // Additional Options
            map.setOptions({fullscreenControl: false});
        } else {
            console.warn("Google Maps Instance not available");
        }

        this.internal = {
            gmaps,
            map,
            directionsDisplay,
            directionsService
        };

    }


    render() {

        let mapZoom = 14;


        const mapStore = this.props.store;

        const mapCenter = {
            lat: mapStore.lat,
            lng: mapStore.lng,
        };

        this.renderDirectionsToOrder(this.props.appState.order.selected);

        return (
            // Important! Always set the container height explicitly
            <div style={{height: '100vh', width: '100%'}}>
                <GoogleMap
                    bootstrapURLKeys={{key: config.googleMapsKey}}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                    center={mapCenter}
                    zoom={mapZoom}
                    // onChange={this.props.onChange}
                    // layerTypes={['TrafficLayer', 'TransitLayer']}
                    onGoogleApiLoaded={({map, maps}) => this.onGoogleApiLoaded(map, maps)}
                    yesIWantToUseGoogleMapApiInternals
                >
                    <StoreMarker
                        key={'store'}
                        lat={mapStore.lat}
                        lng={mapStore.lng}
                        text={mapStore.name}
                    />

                    {this.renderDrivers(this.props)}

                </GoogleMap>
            </div>
        );
    }


    renderDrivers(props) {
        var content = [];

        const highlightedDriver = this.props.appState.driver.highlighted;

        let drivers = this.state.drivers;
        props.drivers.map(driver => {
            let position = this.calculateDriverPosition(driver, drivers);
            content.push(
                <DriverMarker
                    key={`map-driver-${driver.id}`}
                    highlightedDriver={highlightedDriver}
                    data-id={driver.id}
                    driver={driver}
                    lat={position.lat}
                    lng={position.lng}
                />
            )

        });

        this.setupMapUpdate();
        return content;
    }


    updateDriversLocation() {
        // console.log("State: " + JSON.stringify(this.state));
        let drivers = Object.assign({}, this.state.drivers);
        let doUpdate = false;
        Object.keys(drivers).map(key => {
            let driver = drivers[key];
            let transition = driver.transition;
            if (transition.step > 1) {
                transition.step--;
                driver.position.lat += transition.deltaLat;
                driver.position.lng += transition.deltaLng;
                driver.transition = transition;
                doUpdate = true;
            } else if (transition.step === 0) {
                transition.step = 0;
                driver.position.lat = driver.coordinates.lat;
                driver.position.lng = driver.coordinates.lng;
                driver.transition = transition;
                doUpdate = true;
            }

        });


        if (doUpdate) {
            this.setState({drivers});
        } else {
            this.removeMapUpdate();
        }
    }


    calculateDriverPosition(driver, drivers) {
        let position = {};
        if (drivers[driver.id]) {
            let coordinates = drivers[driver.id].coordinates;
            position = drivers[driver.id].position;

            drivers[driver.id].coordinates = {lat: driver.coordinates.lat, lng: driver.coordinates.lng};

            if (MARKER_ANIMATION) {
                if (driver.coordinates.lat !== coordinates.lat || driver.coordinates.lng !== coordinates.lng) {
                    drivers[driver.id].transition = this.computeTransition(position, coordinates);
                }
            } else {
                drivers[driver.id].position = {lat: driver.coordinates.lat, lng: driver.coordinates.lng};
                drivers[driver.id].transition = {step: 0, deltaLat: 0.0, deltaLng: 0.0};
                position = drivers[driver.id].position;
            }

        } else {
            drivers[driver.id] = {
                id: driver.id,
                coordinates: {lat: driver.coordinates.lat, lng: driver.coordinates.lng},
                position: {lat: driver.coordinates.lat, lng: driver.coordinates.lng},
                transition: {step: 0, deltaLat: 0.0, deltaLng: 0.0},
            }

            position = drivers[driver.id];
        }


        return position;
    }


    computeTransition(position, coordinates) {
        let deltaLat = (coordinates.lat - position.lat) / TRANSITION_ITERATIONS;
        let deltaLng = (coordinates.lng - position.lng) / TRANSITION_ITERATIONS;
        var transition = {step: TRANSITION_ITERATIONS, deltaLat, deltaLng};
        return transition;
    }


    renderDirectionsToOrder(order) {
        const googleMaps = this.internal;

        if (!googleMaps.map) {
            console.warn("[" + TAG + "] Cannot draw directions, map not initialized ");
            return; // map not yet initialized
        }


        if (!order) {

            if (this.state.directionsOrder) {
                googleMaps.directionsDisplay.set('directions', null);
                this.state.directionsOrder = undefined;
            }
            return; // unselected order
        }

        if (!googleMaps.directionsService) {
            console.warn("[" + TAG + "] Directions Service not initialized");
            return;
        }


        if (this.state.directionsOrder && this.state.directionsOrder.id === order.id) {
            return; // order directions already rendered. skipping render...
        }

        const orderDriver = this.props.drivers.find(driver => driver.id === (order.driver && order.driver.id));
        const originCoords = orderDriver ?
            {lat: orderDriver.coordinates.lat, lng: orderDriver.coordinates.lng} :
            {lat: this.props.store.lat, lng: this.props.store.lng};


        // Some kind of feature flag
        if (config.features.FEATURE_GOOGLE_DIRECTIONS) {

            googleMaps.directionsService.route({
                origin: originCoords,
                destination: order.postalCode,
                travelMode: googleMaps.gmaps.TravelMode.DRIVING,
            }, (response, status) => {
                if (status === 'OK') {
                    googleMaps.directionsDisplay.set('directions', null);
                    googleMaps.directionsDisplay.setDirections(response);
                    this.state.directionsOrder = order;
                } else {
                    googleMaps.directionsDisplay.set('directions', null);
                    this.state.directionsOrder = null;
                }
            });
        } else {
            openMapWindow(`${this.props.store.lat},${this.props.store.lng}`, `${commons.trimOrderAddress(order).replace(' ', '+')},${order.postalCode}`)
        }
    }



}



const strWindowFeatures = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes";


// targetUrl = 'https://www.google.pt/maps/dir/41.1523099,-8.6393209/Wok+Home,+R.+Direita+de+Aradas+103,+3810-005+Aveiro/@40.8875781,-8.8199979,10z/data=!3m1!4b1!4m12!4m11!1m3!2m2!1d-8.6393209!2d41.1523099!1m5!1m1!1s0xd23a2e5b50e3f99:0xc6c49a5e31e3403f!2m2!1d-8.6454332!2d40.6228416!3e0'
const targetName = 'map_tracker'


var windowLocationUrl = undefined;
function openMapWindow(origin, destination) {
    // let targetUrl = `https://www.google.pt/maps/dir/${origin}/${destination}`
    let targetUrl = `https://www.google.pt/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`
    if (windowLocationUrl === targetUrl){
        return;
    }
    let windowObjectReference = window.open(targetUrl, targetName, strWindowFeatures);
    if (!windowObjectReference) {
        console.error("Failure to open window");
    } else {
        // Wait to capture multiple clicks and lock on the last one
        setTimeout(() => {
            windowLocationUrl = targetUrl;
        }, 2000)
    }
}


// WEBPACK FOOTER //
// ./src/app/Map/index.js